<template>
  <div class="color">
    <p class="color__ttl">
      <SunIcon class="color__sun" /> Тема
    </p>
    <div class="color__btns" ref="buttonsRef">
      <div class="color__caret" :style="caretStyle"></div>
      <button
        v-for="(icon, index) in icons"
        :key="index"
        class="color__icon"
        :class="{ 'color__icon--active': selectedIndex === index }"
        @click="selectTheme(index)"
        ref="themeButtons"
      >
        <component :is="icon" />
      </button>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, nextTick } from 'vue';
  import { useStore } from 'vuex';

  import SunIcon from '@/Groups/ColorThemesManager/private/svg/SunIcon.vue';
  import LightThemeIcon from '@/Groups/ColorThemesManager/private/svg/LightThemeIcon.vue';
  import DarkThemeIcon from '@/Groups/ColorThemesManager/private/svg/DarkThemeIcon.vue';
  import BlueThemeIcon from '@/Groups/ColorThemesManager/private/svg/BlueThemeIcon.vue';

  const store = useStore();

  const icons = [LightThemeIcon, DarkThemeIcon, BlueThemeIcon];
  const themeNames = ['light', 'dark', 'blue'];

  const themeButtons = ref([]);
  const buttonsRef = ref(null);
  const caretLeft = ref('0px');

  const selectedIndex = computed(() => {
    return themeNames.indexOf(store.state.ColorThemesManager.currentTheme);
  });

  const updateCaret = () => {
    nextTick(() => {
      const button = themeButtons.value[selectedIndex.value];
      if (button) {
        caretLeft.value = `${button.offsetLeft}px`;
      }
    });
  };

  const selectTheme = (index) => {
    store.dispatch('ColorThemesManager/setTheme', themeNames[index]);
    updateCaret();
  };

  onMounted(() => {
    themeButtons.value = buttonsRef.value.querySelectorAll('button');
    updateCaret();
  });

  const caretStyle = computed(() => ({
    left: caretLeft.value,
  }));
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>